import { apiRequest } from '@/core';

export const setNewLogoRequest = async ({
  logoUrl,
  externalId,
}: {
  logoUrl: string;
  externalId: string;
}) =>
  apiRequest<never>({
    endpoint: `api/logos`,
    method: 'PATCH',
    body: {
      logoUrl,
      externalId,
    },
  });
